<!-- 修改密码的弹出层 -->
<template>
  <el-dialog
    title="修改密码"
    :visible.sync="isShow"
    :before-close="closeIt"
    width="650px"
    append-to-body
    center
  >
    <el-alert
      title="新密码请满足：大小写英文字符、数字、特殊字符（.@#$%^&*`~_）中的三个，并且长度不小于7"
      type="success"
      :closable="false"
    >
    </el-alert>
    <el-form
      :model="formData"
      :rules="rules"
      label-width="100px"
      ref="passwdRef"
    >
      <el-form-item label="旧密码" prop="originPass">
        <el-input
          v-model="formData.originPass"
          placeholder="请输入就密码"
          autofocus
          clearable
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPass" class="required">
        <el-input
          v-model="formData.newPass"
          placeholder="请按要求输入新密码"
          clearable
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="重复密码" prop="againPasswd" class="required">
        <el-input
          v-model="formData.againPasswd"
          placeholder="请输入重复密码"
          show-password
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="handleSub">确 定</el-button>
      <el-button @click="closeIt">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { changePasswd } from "@/api";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 检验新密码
    const checkPasswd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(""));
      }
      var pattern =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_.@#$%^&*`~]+$)(?![a-z0-9]+$)(?![a-z\W_.@#$%^&*`~]+$)(?![0-9\W_.@#$%^&*`~]+$)[a-zA-Z0-9\W_.@#$%^&*`~]{7,16}/;
      // 校验是否符合正则：大小写英文、数字、特殊字符中选出三个
      if (!pattern.test(value)) callback(new Error("新密码不符合要求！"));
      callback();
    };
    // 重复密码等于新密码即可
    const checkAgainPasswd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("重复密码不能为空"));
      }

      if (value !== this.formData.newPass) {
        callback(new Error("重复密码与新密码不一样"));
      }
      callback();
    };

    return {
      formData: {
        originPass: "",
        newPass: "",
        againPasswd: "",
      },
      rules: {
        originPass: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
        newPass: [{ validator: checkPasswd, trigger: "blur" }],
        againPasswd: [{ validator: checkAgainPasswd, trigger: "blur" }],
      },
    };
  },
  methods: {
    handleSub() {
      this.$refs.passwdRef.validate((valid) => {
        if (!valid) return false;
        const info = JSON.parse(
          JSON.stringify(this.formData, ["originPass", "newPass"])
        );

        this.sendPut(info);
      });
    },
    async sendPut(info) {
      const res = await changePasswd(info);

      if (res.status !== 200) return this.$message.error("修改密码失败！");

      this.$message.success("修改成功");
      setTimeout(() => {
        this.closeIt();
      }, 800);
    },
    closeIt() {
      this.$emit("closeIt", false);
    },
  },
};
</script>
